import { getUserId } from "@/services/supabase/auth/actions/getUserId";
import { supabase } from "@/services/supabase/createClient";
import { v2 } from "@pufflig/prompt-studio-types";
import { useQuery } from "@tanstack/react-query";

export type ProviderApiKeysArgs = {
  team_id?: string;
};

export const getSecrets = async (team_id?: string) => {
  const p_principal_id = team_id || (await getUserId());

  const { data, error } = await supabase.rpc("get_secrets_by_owner", { p_principal_id });

  if (error) {
    throw error;
  }

  return data.reduce((acc: Record<string, v2.SecretResource>, secret) => {
    return {
      ...acc,
      [secret.resource_id]: {
        resourceId: secret.resource_id,
        createdAt: secret.created_at,
        name: secret.name,
        description: secret.description,
        isReady: true,
        resourceType: "secret",
        value: secret.secret,
      } as v2.SecretResource,
    };
  }, {});
};

export const useSecrets = (team_id?: string) => {
  return useQuery({
    queryKey: ["secrets", team_id],
    queryFn: () => getSecrets(team_id),
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
};
